import { IDecayQuery } from '@models/decay/decay-estimate';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '@app/app.config.provider';
import { IDecayClosedAccount } from '@models/decay/decay-closed-account';

@Injectable({
  providedIn: 'root'
})
export class DecayClosedAccountsService {
  private apiUrl: string;

  constructor(private readonly appConfig: AppConfigProvider, private readonly http: HttpClient) {
    this.appConfig.environment.subscribe(env => {
      this.apiUrl = `${env.API.DECAY}/api/decay/closed-accounts`;
    });
  }

  public getDecayClosedAccounts(query: IDecayQuery) {
    return this.http.post<IDecayClosedAccount[]>(this.apiUrl, query);
  }
}
